<template>
  <div
    v-if="isVisible && !cookiesAcceptedState && showBannerState"
    class="fixed bottom-0 left-0 z-[9999999999] w-full"
  >
    <s-banner
      :first-button-text="firstButtonText"
      :message="message"
      :second-button-text="secondButtonText"
      icon="mdi-information"
      @first-button-click="handleFirstButtonClick"
      @second-button-click="handleSecondButtonClick"
    />
  </div>
</template>

<script setup lang="ts">
import { SBanner } from 'sima-suite-components-vue3'
import { ref, computed, onMounted } from 'vue'
import { decodeCookie, getCookiesUrl as fetchCookiesUrl } from '@/utils/CookiesWrapper.ts'
import { useHost } from '@/composables'

interface Props {
  isVisibleInitially: boolean
  firstButtonText: string
  message: string
  secondButtonText: string
}

const props = defineProps<Props>()

const { cookiesUrl: hostCookiesUrl } = useHost()

const showBannerState = ref(true)
const localCookiesUrl = ref<string | undefined>(undefined)

const cookiesAcceptedState = computed(() => decodeCookie('cookiesAccepted') === 'true')

const isVisible = computed(() => props.isVisibleInitially)

const handleFirstButtonClick = () => {
  if (localCookiesUrl.value) {
    window.open(localCookiesUrl.value, '_blank')
  }
}

const handleSecondButtonClick = () => {
  document.cookie = 'cookiesAccepted=true;path=/'
  showBannerState.value = false
}

onMounted(async () => {
  if (props.isVisibleInitially) {
    if (hostCookiesUrl.value) {
      localCookiesUrl.value = hostCookiesUrl.value
    } else {
      await fetchCookiesUrl()
      localCookiesUrl.value = hostCookiesUrl.value
    }
  }
})
</script>
